import { all, takeLatest } from 'redux-saga/effects'
import store from '../../store'
import { actions } from './Receivings.slice'
import { paginate } from './Receivings.thunk'

function paginateReceivings () {
  store.dispatch(paginate() as any)
}

export default function * effects () {
  yield all([
    takeLatest(actions.replaceLimit, paginateReceivings),
    takeLatest(actions.replacePage, paginateReceivings),
    takeLatest(actions.replaceSearch, paginateReceivings)
  ])
}
